import Cookies from 'js-cookie';
import { ABANDONED_CART_ATTRIBUTION_STORAGE_KEY } from './abandonedCartAttribution';

// Per-parent state the ordering flow parks outside Redux. The gallery key is
// the credential that grants access to a student's gallery, so leaving it in
// sessionStorage after a logout hands the next person on a shared device
// (a library, a school computer) the previous parent's dashboard. The
// abandoned-cart stash would send the next parent's login to the previous
// parent's reminder cart.
const PARENT_SESSION_STORAGE_KEYS = [
  'dashboard_gallery_key',
  ABANDONED_CART_ATTRIBUTION_STORAGE_KEY,
];

// Entry-point cookies set when a parent follows a marketing or event link.
// They steer the dashboard's first render, so a stale one would redirect the
// next parent into the previous parent's event.
const PARENT_COOKIE_KEYS = [
  'active_redirect',
  'campaign_event_id',
  'pics_event_key',
  'product_key',
];

// Clears everything the logout Redux wipe cannot reach. Safe to call when
// storage is unavailable (private browsing, blocked site data).
export const clearParentBrowserState = (): void => {
  try {
    PARENT_SESSION_STORAGE_KEYS.forEach((key) =>
      window.sessionStorage.removeItem(key),
    );
  } catch {
    /* sessionStorage unavailable — nothing to clear */
  }

  PARENT_COOKIE_KEYS.forEach((key) => Cookies.remove(key));
};

export default clearParentBrowserState;
